import React from 'react'

import { mapStyles } from 'Utils/data/maps'
import { stores } from 'Utils/data/stores'
import Map from 'Components/Map/Map'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from 'Components/Stores/StoreAddress/StoreAddress.scss'
import { setInfoWindowStyles } from 'Utils/helpers/maps';

type PropType = {
  currentStore?: Webshop.IStoreData
  stores?: Webshop.IStoreData[]
}

class StoresMap extends React.Component<PropType> {
  $style: HTMLStyleElement | null = null

  componentDidMount() {
    this.$style = setInfoWindowStyles()
  }

  componentWillUnmount() {
    this.$style && document.head.removeChild(this.$style)
  }

  get stores(): Webshop.IStoreData[] {
    return (this.props.stores || stores)
  }

  getLocationCenter = () => {
    const sum = this.stores
      .reduce((sum, store) => ({
        lat: store.coordinates.lat + sum.lat,
        lng: store.coordinates.lng + sum.lng
      }), { lat: 0, lng: 0 })

    return {
      lat: sum.lat / stores.length,
      lng: sum.lng / stores.length
    }
  }

  initGoogleMaps = (map: google.maps.Map) => {
    let openedWindow: google.maps.InfoWindow | null = null

    this.stores.forEach(store => {
      const marker = new google.maps.Marker({
        position: store.coordinates,
        map,
        icon: {
          scaledSize: new google.maps.Size(32, 32),
          url: this.props.currentStore && store.id === this.props.currentStore.id
            ? '/static/illustration/g-pins/g-pin-negative.svg'
            : '/static/illustration/g-pins/g-pin-basic.svg'
        },
        title: store.name
      })

      const title = store.noLink
        ? store.name
        : `<a href="/uzletek/${store.id}">${store.name}</a>`

      const infoWindow = new google.maps.InfoWindow({
        content: `
          <div class="${cn(cl.storeAddress, cl.storeAddress__infoWindow)}">
            <h1 class="${cn(cg.textCenter, cl.h1)}">${title}</h1>
            <p class="${cl.storeAddress__addressWrapper}">${store.address}<br />${store.details}</p>
            <h2 class="${cl.h2}">Ügyfélszolgálat nyitvatartás</h2>
            ${store.opening_hours.map(hour =>
          `<dl class="${cn(cg.gridX, cg.gridPaddingX, cg.alignMiddle, cl.storeAddress__openingHours)}">
                <dt class="${cn(cg.cell, cg.auto)}">${hour.label}: </dt>
                <dd class="${cn(cg.cell, cg.shrink)}">${hour.value}</dd>
              </dl>`
        ).join('')}
            <div class="${cl.storeAddress__contactWrapper}">
              <div>
                <a href="${`mailto:${store.email}`}">
                  <span class="${cl.underline}">
                    ${store.email}
                  </span>
                </a>
              </div>
              <div>
                <a href="${`tel:${store.phone}`}">
                  <span>
                    📞 ${store.phone}
                  </span>
                </a>
              </div>
            </div>
          </div>`
      })

      marker.addListener('click', () => {
        if (openedWindow !== null) {
          openedWindow.close()
        }
        openedWindow = infoWindow
        infoWindow.open(map, marker)
      })

      if (this.props.currentStore && store.id === this.props.currentStore.id) {
        infoWindow.open(map, marker)
        openedWindow = infoWindow
      }
    })
  }

  render = () =>
    <Map
      onInit={this.initGoogleMaps}
      config={{
        center: this.getLocationCenter(),
        styles: mapStyles,
        zoom: 13,
        zoomControl: false
      }}
    />
}

export default StoresMap
